import { footerLinks } from "@/mocks/homeData";
import { useState } from "react";

export default function Footer() {
  const [email, setEmail] = useState("");

  return (
    <footer className="w-full bg-secondary-50 border-t border-secondary-200">
      <div className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-6">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div className="mb-4">
              <h3 className="text-xl font-bold text-foreground-950 mb-1">
                ママノベスト
              </h3>
              <p className="text-xs text-foreground-500">mama no best</p>
            </div>
            <p className="text-xs text-foreground-600 leading-relaxed mb-5">
              ママの「選ぶ」を応援する情報サイト。
              <br />
              実際に使えたココロをおすすめのアイテムを
              <br />
              紹介しています。
            </p>
          </div>

          {/* By Age */}
          <div>
            <h4 className="text-sm font-bold text-foreground-800 mb-4">
              年齢から探す
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.byAge.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-xs text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* By Category */}
          <div>
            <h4 className="text-sm font-bold text-foreground-800 mb-4">
              カテゴリから探す
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.byCategory.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-xs text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Features + About */}
          <div>
            <h4 className="text-sm font-bold text-foreground-800 mb-4">
              特集一覧
            </h4>
            <ul className="space-y-2.5 mb-6">
              {footerLinks.features.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-xs text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>

            <h4 className="text-sm font-bold text-foreground-800 mb-4">
              お役立ち
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-xs text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Newsletter */}
        <div className="mt-8 pt-8 border-t border-secondary-200">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div>
              <h4 className="text-sm font-bold text-foreground-800 mb-1">
                新着記事を受け取る
              </h4>
              <p className="text-xs text-foreground-500">
                メールマガジンに登録して、最新情報をゲット！
              </p>
            </div>
            <div className="flex w-full md:w-auto gap-2">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="メールアドレスを入力"
                className="flex-1 md:w-64 px-4 py-2.5 rounded-full border border-secondary-200 text-sm bg-white outline-none focus:border-primary-300"
              />
              <button className="bg-primary-500 text-white px-5 py-2.5 rounded-full text-sm font-bold hover:bg-primary-600 transition-colors whitespace-nowrap">
                登録する
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-foreground-500 hover:text-primary-500 transition-colors"
            >
              <i className="ri-instagram-line text-lg"></i>
            </a>
            <a
              href="#"
              className="text-foreground-500 hover:text-primary-500 transition-colors"
            >
              <i className="fa-brands fa-line text-lg"></i>
            </a>
            <a
              href="#"
              className="text-foreground-500 hover:text-primary-500 transition-colors"
            >
              <i className="ri-youtube-line text-lg"></i>
            </a>
            <a
              href="#"
              className="text-foreground-500 hover:text-primary-500 transition-colors"
            >
              <i className="fa-brands fa-x-twitter text-lg"></i>
            </a>
          </div>
          <p className="text-xs text-foreground-500">
            &copy; mamanobest.com All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}